module.exports = __webpack_public_path__ + "img/KSC08287.98330449.jpg";